import { Redirect, Route, RouteProps } from 'react-router';
import { IUserRole } from 'types/Auth';

export const SignInRoute = ({ children, ...props }: RouteProps) => {
  const isAuthenticated = localStorage.getItem('user');
  const role = localStorage.getItem('role') as IUserRole;

  return (
    <Route
      {...props}
      render={({ location }) => {
        return isAuthenticated ? (
          <Redirect
            to={{
              pathname:
                role === 'partner' ? '/partner/profile' : `/${role}/dashboard`,
              state: { from: location },
            }}
          />
        ) : (
          children
        );
      }}
    />
  );
};

